<!-- 销售订单 -->
<template>
  <div class='page_content'>
    <div class="page_content_top">
      <v-button :btnFlag="false" :buttonFlag="false">
        <template slot="button">
          <div>
            <el-button type="primary" size="mini" @click="openDialog(0)">新增</el-button>
            <el-button type="primary" size="mini" @click="openDialog(1)">修改</el-button>
            <el-button type="primary" size="mini" @click="delPrice">删除</el-button>
          </div>
        </template>
      </v-button>
    </div>
    <div class="page_content_center">
      <el-table size="mini" border highlight-current-row :height="tableHeight" :key="$store.state.tableNum" :data="formList">
        <el-table-column align="center" label="选择" width="90">
          <template slot-scope="scope">
            <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
              <i class="el-icon-thumb"></i>
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column align="center" label="级别名称" prop="levleName"></el-table-column>
        <el-table-column align="center" label="创建时间" prop="createTime">
          <template slot-scope="scope">
            {{ $common.getLocalTime(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="备注" prop="remark"></el-table-column>
      </el-table>
    </div>
    <el-drawer :close-on-press-escape="true" :visible.sync="msgDialogVisible" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="50%">
      <salesPriceStrategyAction v-if="msgDialogVisible" ref="salesPriceStrategyAction" @drawerCancel="drawerCancel" :actionData="actionData"></salesPriceStrategyAction>
    </el-drawer>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import salesPriceStrategyAction from "@/components/salesPriceStrategyAction.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {salesPriceStrategyAction},
  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      actionData: {},
      getRequestData: {
        "creater": 0,
        "end": 0,
        "levleName": "",
        "ormId": 0,
        "page": 1,
        "rows": 10,
        "start": 0
      },
      returnData: {},
      formList: [],
      msgDialogVisible: false,
      selectedDataIndex: 0,
      typeCase: 0
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {

  },
  //方法集合
  methods: {
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val
      this.getDataList()
    },
    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1
      this.getRequestData.rows = val
      this.getDataList()
    },
    //调取弹窗
    openDialog(typ) {
      if (typ == 1) {
        this.typeCase = 1
        const oldData = JSON.parse(JSON.stringify(this.formList[this.selectedDataIndex]))
        this.actionData = {
          cate: 1,
          formData: '',
          oldData,
          orderId: '',
          printSouce: '',
          printJurId: ''
        }
        // console.log(this.formList[this.selectedDataIndex]);
      } else {
        this.actionData = {
          cate: 0,
          formData: '',
          oldData: '',
          orderId: '',
          printSouce: '',
          printJurId: ''
        }
        this.typeCase = 0
      }

      this.msgDialogVisible = true
    },
    drawerCancel() {
      this.msgDialogVisible = false
      this.getDataList()
    },
    //删除价格策略
    delPrice() {
      var that = this
      this.$confirm('确定删除此价格策略吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = [that.formList[that.selectedDataIndex].levleId]
        that.$http.delPriceStrategy({ ids: ids }).then((res) => {
          // console.log(res);
          if (res.status == 200) {
            that.msgDialogVisible = false
            that.getDataList()
            that.$message({
              message: '删除成功',
              type: 'success'
            });
          } else {
            that.$message({
              message: '删除失败',
              type: 'error'
            });
          }
        })
      }).catch(() => { })
    },
    // 获取数据列表
    async getDataList() {
      let responseData = await this.$http.getPriceStrategy(this.getRequestData)
      // console.log(responseData,this.getRequestData);
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list
        this.returnData.pages = responseData.result.pages
        this.returnData.total = responseData.result.total
        this.returnData.pageNum = responseData.result.pageNum
        this.selectedDataIndex = 0
        this.formList = this.returnData.list
      } else {
        this.$message({
          message: '获取数据失败。。',
          type: 'error'
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getDataList()

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = this.$common.getTableHeight();
      console.log(this.$common.getTableHeight());
    })
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {

  }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}
</style>
